import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { it } from 'date-fns/locale';
import { useEffect, useState } from "react";

//components
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

//api
import { ElaborationService } from "../../service/elaboration-service";


const ElaborationList = ({refreshTrigger})=>{
    const navigate = useNavigate()
    const [elaborations, setElaborations] = useState([])

    useEffect(()=>{
        const fetchElaborations = ()=>{
            ElaborationService.getAllElaborations(
                (data)=>{
                    if(data && Array.isArray(data.results)){
                        const formattedElaborations = data.results.map(elab=>({
                            ...elab,
                            created_at: elab.created_at ? format(new Date(elab.created_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            updated_at: elab.updated_at ? format(new Date(elab.updated_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            started_at: elab.started_at ? format(new Date(elab.started_at), 'dd MMMM yyyy HH:mm', { locale: it }) : '',
                            completed_at: elab.completed_at ? format(new Date(elab.completed_at),'dd MMMM yyyy HH:mm', { locale: it }): ''
                        }));
                        setElaborations(formattedElaborations)
                    } else {
                        const errorMessage = "La risposta non contiene un array valido di elaborazioni.";
                        console.error(errorMessage);
                    }
                },
                (error) => {
                    console.error("Errore durante il recupero dei progetti: ", error);
                }
            )
        }
        fetchElaborations()
    },[refreshTrigger])

    const getStatusColor = (status)=>{
        let statusColor = '';
        let statusText = '';
        switch (status){
            case 'pending':
                statusColor = 'orange';
                statusText = 'IN ATTESA';
                break;
            case 'processing':
                statusColor = 'blue';
                statusText = 'IN ELABORAZIONE';
                break;
            case 'in_progress':
                statusColor = 'blue';
                statusText = 'IN ELABORAZIONE';
                break;
            case 'completed':
                statusColor = 'green';
                statusText = 'COMPLETATO';
                break;
            case 'failed':
                statusColor = 'red';
                statusText = 'FALLITO';
                break;
            default:
                statusColor = 'black'
                statusText = status.toUpperCase();
        }
        return <span style={{ color: statusColor }}>{statusText}</span>;
    }

    return (
        <div className="card projectTable__TableWrapper" style={{marginLeft:'2rem'}}>
            <h2>Lista Elaborazioni</h2>
            <DataTable value={elaborations} tableStyle={{ minWidth: '50rem' }} className='projectTable__Table'  style={{marginRight:'2rem'}}>
                <Column field="project_name" header="Nome"></Column>
                <Column field="created_at" header="Data Creazione"></Column>
                <Column field="updated_at" header="Ultimo Aggiornamento"></Column>
                <Column field="started_at" header="Inizio"></Column>
                <Column field="completed_at" header="Completato"></Column>
                <Column field="status" header="Stato" 
                body={(rowData)=>getStatusColor(rowData.status)}
                ></Column>
                <Column
                    header=""
                    body={(rowData) => (
                        <Button
                            label="Gestisci"
                            className="p-button-sm"
                            onClick={() => {
                                const elabId = rowData.id;
                                navigate(`/dashboard/elaborations/${elabId}`);
                            }}
                        />
                    )}
                ></Column>
            </DataTable>
        </div>
    );
}

export default ElaborationList